import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const tmaisNfcesStatusOptions = [
  { label: 'Pendente', value: 'pending' },
  { label: 'Falha', value: 'failed' },
  { label: 'Aprovada', value: 'approved' },
  { label: 'Rejeitada', value: 'rejected' },
]

export const tmaisNfcesStatusStrategy = optionsToStrategy(tmaisNfcesStatusOptions)
